import React from "react";

import Str from "shared/components/Str";
import OkCSSLoader from "shared/components/OkCSSLoader";

import "apps/messenger/components/MainWindow/MessagePane/LoadingIndicator.scss";

const LoadingIndicator = () => (
	<div className="messenger-loading-indicator">
		<Str>Loading</Str>
		<OkCSSLoader
			className="messenger-loading-indicator-spinner"
			size={OkCSSLoader.Size.xtiny}
			show
		/>
	</div>
);

export default LoadingIndicator;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/MainWindow/MessagePane/LoadingIndicator.jsx